/**
 * G2. Урок: четыре предмета, расставить по интересу (кнопки «Выше/Ниже»
 * и стрелки). Сильный учитель подсказан: его предмет первым — знания +3.
 */
import { t } from '@life/i18n';
import { LESSON_KNOWLEDGE_BY_RANK, lessonSubjectKey, type LessonInput, type LessonState } from '@life/minigames';
import { useState } from 'preact/hooks';
import type { MinigameScreenProps } from './types';
import { Order } from './ui/Order';

export function Lesson({ state, onInput }: MinigameScreenProps<LessonInput, LessonState>) {
  const [order, setOrder] = useState<number[]>(() => state.subjects.map((_s, i) => i));
  const [top, second] = LESSON_KNOWLEDGE_BY_RANK;
  return (
    <>
      <p class="hint">{t('ui.minigame.lesson.rules', { top, second })}</p>
      <p class="hint">{t('minigame.lesson.strong', { subject: t(lessonSubjectKey(state.strong)) })}</p>
      <Order
        label={t('ui.minigame.lesson.label')}
        items={state.subjects.map((s) => t(lessonSubjectKey(s)))}
        notes={state.subjects.map((s) => (s === state.strong ? t('ui.minigame.lesson.strongNote') : undefined))}
        order={order}
        onChange={setOrder}
      />
      <button type="button" class="btn accent block" onClick={() => onInput({ order })}>
        {t('ui.minigame.lesson.submit')}
      </button>
    </>
  );
}
